module.exports = __webpack_public_path__ + "static/media/ecommerce_original.b8203c34.jpg";